// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.flight-divider[data-v-4a2bb960] {\n  font-weight: 700;\n  position: relative;\n  top: -25px;\n}\n.flight-divider-text[data-v-4a2bb960] {\n  text-transform: uppercase;\n}\n", ""]);
// Exports
module.exports = exports;
